(function () {
  function bindTilt() {
    document.querySelectorAll('.os-genz-card, .os-product-main-media').forEach((card) => {
      if (card.dataset.osTiltBound) return;
      card.dataset.osTiltBound = 'true';
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width - 0.5) * 9;
        const y = ((event.clientY - rect.top) / rect.height - 0.5) * -9;
        card.style.transform = `perspective(900px) rotateY(${x}deg) rotateX(${y}deg) translateY(-4px)`;
      });
      card.addEventListener('pointerleave', () => {
        card.style.transform = '';
      });
    });
  }

  function bindCursorOrb() {
    if (!window.matchMedia('(pointer: fine)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    let orb = document.querySelector('.os-cursor-orb');
    if (!orb) {
      orb = document.createElement('div');
      orb.className = 'os-cursor-orb';
      orb.setAttribute('aria-hidden', 'true');
      document.body.prepend(orb);
    }
    if (document.documentElement.dataset.osCursorBound) return;
    document.documentElement.dataset.osCursorBound = 'true';
    window.addEventListener('pointermove', (event) => {
      document.documentElement.style.setProperty('--os-mx', `${event.clientX}px`);
      document.documentElement.style.setProperty('--os-my', `${event.clientY}px`);
    }, { passive: true });
  }

  function bindProductPage() {
    document.querySelectorAll('[data-os-product-page]').forEach((section) => {
      if (section.dataset.osProductBound) return;
      section.dataset.osProductBound = 'true';
      const productScript = section.querySelector('[data-os-product-json]');
      const product = productScript ? JSON.parse(productScript.textContent) : null;
      const form = section.querySelector('[data-os-product-form]');
      const variantInput = section.querySelector('[data-os-variant-id]');
      const price = section.querySelector('[data-os-price]');
      const add = section.querySelector('[data-os-add]');
      const moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '{{amount}}';
      const format = (cents) => window.Shopify && Shopify.formatMoney ? Shopify.formatMoney(cents, moneyFormat) : `Rs. ${(cents / 100).toLocaleString('en-IN')}`;

      section.querySelectorAll('[data-os-thumb]').forEach((button) => {
        button.addEventListener('click', () => {
          const img = section.querySelector('.os-product-main-media img');
          if (img) {
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
            img.src = button.dataset.osThumb;
          }
        });
      });

      if (!product || !form) return;
      const syncVariant = () => {
        const selected = Array.from(section.querySelectorAll('[data-os-option]:checked')).map((input) => input.value);
        const variant = product.variants.find((item) => item.options.every((option, index) => option === selected[index]));
        if (!variant) return;
        variantInput.value = variant.id;
        if (price) price.textContent = format(variant.price);
        if (add) {
          add.disabled = !variant.available;
          add.textContent = variant.available ? 'Add to bag' : 'Sold out';
        }
      };
      section.querySelectorAll('[data-os-option]').forEach((input) => input.addEventListener('change', syncVariant));
      syncVariant();
    });
  }

  function init() {
    bindTilt();
    bindCursorOrb();
    bindProductPage();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();

(function () {
  function updateHeaderState() {
    var hero = document.querySelector('.os-genz-hero');
    if (!hero || !document.body.classList.contains('template-index')) return;
    var threshold = hero.getBoundingClientRect().bottom + window.scrollY - 20;
    document.body.classList.toggle('os-past-hero', window.scrollY > threshold);
  }

  function openCartDrawer() {
    document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
    refreshCartRecommendations();
    if (window.Spruce && Spruce.store) {
      try { Spruce.store('drawer').cartDrawerOpen = true; } catch (e) {}
    }
  }

  function rotateList(items, offset) {
    if (!items.length) return [];
    var normalized = offset % items.length;
    return items.slice(normalized).concat(items.slice(0, normalized));
  }

  function refreshCartRecommendations() {
    var grid = document.querySelector('[data-os-cart-reco-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-os-cart-reco-card]'));
    if (!cards.length) return;
    var seed = parseInt(grid.dataset.osRecoSeed || '0', 10) + 1;
    grid.dataset.osRecoSeed = String(seed);

    var denimCards = cards.filter(function (card) {
      return card.dataset.osRecoKind === 'denim';
    });
    var generalCards = cards.filter(function (card) {
      return card.dataset.osRecoKind !== 'denim';
    });
    var visible = [];
    var denimPick = rotateList(denimCards, seed - 1)[0];
    if (denimPick) visible.push(denimPick);

    var mobileCart = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (!mobileCart) {
      var generalPool = rotateList(generalCards.length ? generalCards : cards.filter(function (card) {
        return card !== denimPick;
      }), seed);
      if (generalPool[0]) visible.push(generalPool[0]);
      if (visible.length < 2 && cards.find(function (card) { return visible.indexOf(card) === -1; })) {
        visible.push(cards.find(function (card) { return visible.indexOf(card) === -1; }));
      }
    }

    cards.forEach(function (card) {
      card.hidden = visible.indexOf(card) === -1;
    });
  }

  function closeCardSizePanels(exceptForm) {
    document.querySelectorAll('.os-genz-card__form[data-os-card-form]').forEach(function (form) {
      if (form === exceptForm) return;
      var panel = form.querySelector('[data-os-size-panel]');
      var toggle = form.querySelector('[data-os-size-toggle]');
      if (panel) panel.hidden = true;
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function bindQuickSizePanels() {
    document.querySelectorAll('.os-genz-card__form[data-os-card-form]').forEach(function (form) {
      if (form.dataset.osSizePanelBound) return;
      form.dataset.osSizePanelBound = 'true';
      var toggle = form.querySelector('[data-os-size-toggle]');
      var panel = form.querySelector('[data-os-size-panel]');
      if (!toggle || !panel) return;

      toggle.addEventListener('click', function () {
        var isOpen = !panel.hidden;
        closeCardSizePanels(form);
        panel.hidden = isOpen;
        toggle.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    if (!document.documentElement.dataset.osCardPanelDismissBound) {
      document.documentElement.dataset.osCardPanelDismissBound = 'true';
      document.addEventListener('click', function (event) {
        if (!event.target.closest('.os-genz-card__form[data-os-card-form]')) {
          closeCardSizePanels();
        }
      });
      document.addEventListener('keyup', function (event) {
        if (event.key === 'Escape') closeCardSizePanels();
      });
    }
  }

  function bindAjaxCartAdds() {
    document.querySelectorAll('.os-product-form, .os-genz-card__form[data-os-card-form]').forEach(function (form) {
      if (form.dataset.osAjaxCartBound) return;
      form.dataset.osAjaxCartBound = 'true';
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        var isCardForm = form.matches('.os-genz-card__form[data-os-card-form]');
        var submitter = event.submitter || document.activeElement;
        var variantButton = isCardForm && submitter ? submitter.closest('[data-os-variant-id]') : null;
        var variantInput = form.querySelector('input[name="id"]');

        if (isCardForm) {
          if (!variantButton || variantButton.disabled) {
            var panel = form.querySelector('[data-os-size-panel]');
            var toggle = form.querySelector('[data-os-size-toggle]');
            closeCardSizePanels(form);
            if (panel) panel.hidden = false;
            if (toggle) toggle.setAttribute('aria-expanded', 'true');
            return;
          }
          if (variantInput) variantInput.value = variantButton.dataset.osVariantId;
        }

        var button = form.querySelector('button[type="submit"], .os-product-add');
        var originalText = button ? button.textContent : '';
        if (button) {
          button.disabled = true;
          button.textContent = 'Adding...';
        }
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) throw new Error('Cart add failed');
            return response.json();
          })
          .then(function () {
            if (isCardForm) closeCardSizePanels();
            openCartDrawer();
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            if (button) {
              button.disabled = false;
              button.textContent = originalText;
            }
          });
      });
    });
  }

  function loadContinuousCollectionProducts() {
    var grid = document.getElementById('CollectionProductGrid');
    if (!grid || grid.dataset.osContinuousLoading === 'true') return;
    var list = grid.querySelector('.collection-list.os-genz-product-grid');
    var marker = grid.querySelector('[data-os-continuous-next-page]');
    if (!list || !marker || !marker.dataset.osNextPageUrl) return;

    grid.dataset.osContinuousLoading = 'true';

    var loadNext = function (nextUrl) {
      var url = new URL(nextUrl, window.location.origin);
      var section = document.querySelector('[data-section-type="collection"][data-section-id]');
      if (section) url.searchParams.set('section_id', section.dataset.sectionId);

      fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Collection page load failed');
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = parsed.getElementById('CollectionProductGrid');
          var nextList = nextGrid && nextGrid.querySelector('.collection-list.os-genz-product-grid');
          if (!nextList) return;

          Array.prototype.slice.call(nextList.children).forEach(function (item) {
            list.appendChild(document.importNode(item, true));
          });

          var currentMarker = grid.querySelector('[data-os-continuous-next-page]');
          if (currentMarker) currentMarker.remove();

          var nextMarker = nextGrid.querySelector('[data-os-continuous-next-page]');
          if (nextMarker && nextMarker.dataset.osNextPageUrl) {
            grid.appendChild(document.importNode(nextMarker, true));
            document.dispatchEvent(new Event('shopify:section:load'));
            loadNext(nextMarker.dataset.osNextPageUrl);
          } else {
            grid.dataset.osContinuousComplete = 'true';
            grid.dataset.osContinuousLoading = 'false';
            document.dispatchEvent(new Event('shopify:section:load'));
          }
        })
        .catch(function () {
          grid.dataset.osContinuousLoading = 'false';
        });
    };

    loadNext(marker.dataset.osNextPageUrl);
  }

  function bindContinuousCollectionObserver() {
    var grid = document.getElementById('CollectionProductGrid');
    if (!grid || grid.dataset.osContinuousObserver === 'true') return;
    grid.dataset.osContinuousObserver = 'true';
    new MutationObserver(function () {
      window.requestAnimationFrame(loadContinuousCollectionProducts);
    }).observe(grid, { childList: true });
  }

  function initHomeChangePass() {
    updateHeaderState();
    bindQuickSizePanels();
    bindAjaxCartAdds();
    bindContinuousCollectionObserver();
    loadContinuousCollectionProducts();
    refreshCartRecommendations();
  }

  window.addEventListener('scroll', updateHeaderState, { passive: true });
  window.addEventListener('resize', updateHeaderState, { passive: true });
  document.body.addEventListener('baseline:modalcart:afteradditem', refreshCartRecommendations);
  document.addEventListener('DOMContentLoaded', initHomeChangePass);
  document.addEventListener('shopify:section:load', initHomeChangePass);
})();
